import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=39bb4d03&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=ts"
export * from "./Pdf.vue?vue&type=script&lang=ts"
import style0 from "@/styles/OcStyles.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Pdf.vue?vue&type=style&index=1&id=39bb4d03&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb4d03",
  null
  
)

export default component.exports